
<template>
  <div>
    <dialog-create-employee></dialog-create-employee>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateEmployee from '../../components/employee/DialogCreateEmployee.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'NewEmployeePage',
  //mixins: [ validations ],
  components: {
    DialogCreateEmployee
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>